// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__2T3bg","head":"Table_head__70qGe","col":"Table_col__3PzuH"};